import React from 'react';
import {Trim} from '../types/data';

const CarImage: React.FC<{trimDetails: Trim; modelName: string, modelYear: string}> = ({
  trimDetails,
  modelName,
  modelYear
}) => {
  return <img src={`https://globalapi.vwtools.ca/api/okapi/images/?year=${modelYear}&model_code=${trimDetails.sales_code}&rotation=015`} alt={modelName + ' ' + modelYear + ' ' + trimDetails.name} />;
};

export default CarImage;
